import Link from 'next/link';

import { getNaturalTimeString, apiHome, window_open_pt } from '../../../common/basic';


export default props=>{
  if (!props.me || !props.data ) return <></>;
  if(props.me.post_type==4){
    // console.log("props.me: ", props.me);
    // console.log("props.data: ", props.data);

  }

  const jsx = (
    <a onClick={() => {
      // console.log(": ", props.me.post_type);
      if (props.me.post_type == 3) location.href = "/magazine/" + props.me.id;
      // else window.open("/magazine2/detail?cid=" + props.me.id, props.me.id, "scrollbars=no,width=1290,height=965");
      else window_open_pt("/magazine2/detail?cid=" + props.me.id, "pt" + props.me.id);
    }}>

<div className="item-panel seed">
    <style jsx>{`
.image {
  width: 100%;
}


.seed{
  height: 470px;
  font-family: NotoSansCJKkr;
  font-size: 14px;
}


.l1{
  height: 270px;
  /* padding-top: 14px; */
  position: relative;
  overflow: hidden;
}

.l2{
  padding-top: 14px;
  color: #ff6b6b;
}


.l3{

  font-size: 23px;
  font-weight: bold;
  letter-spacing: -0.25px;
  color: #343a40;

  margin-top: 6px;

  /* position: absolute;
  top: 20px;
  right: 0;

  line-height: 50px; */
}


.l33{
  position: absolute;
  top: 20px;
  right: 0;
}


.l4{
  padding-top: 12px;
  color: #343a40;
}

.l5{
  padding-top: 18px;
  font-size: 12px;
  color: #868e96;
}

img,span {
  vertical-align:middle;
  color: #adb5bd;
}


@media all and (max-width:606px) {

  .l1{
    padding-top: 0px;
  }

  .l2{
    padding-top: 7px;
  }

  .l4{
      font-size: 14px;
      line-height: 1.71;
  }

  .l5{
    padding-top: 16px;
  }

  .seed{
    height: auto;
  }
}

.vertically-middle{
  transition: transform .5s;
}

.vertically-middle:hover{
  transform: translate(-50%, -50%) scale(1.05);
  transition: transform 1s;
}

`}</style>
    <div className="l1">
      {/* <a onClick={()=>{
        // console.log(": ", props.me.post_type);
        if(props.me.post_type == 3) location.href="/magazine/"+props.me.id;
        // else window.open("/magazine2/detail?cid=" + props.me.id, props.me.id, "scrollbars=no,width=1290,height=965");
        else window_open_pt("/magazine2/detail?cid=" + props.me.id, "pt"+props.me.id);
      }}> */}
        {/* <img className="image" src={"/assets/images/crop/e1.png"} /> */}
        <img className="image vertically-middle" 
          src={
            props.me.post_type==3?
            (props.data.thumbnail ? apiHome.split('/v1').join('') + props.data.thumbnail.targetFullPath : "")
              : ((props.data.sections && props.data.sections.length > 0 && props.data.sections[0].pictureSet.targetFullPath) ?
                (apiHome.split('/v1').join('') + props.data.sections[0].pictureSet.targetFullPath):""
              )
          } 
          onError={e=>e.target.src = "/assets/images/crop/e1.png"} 
        />
      {/* </a> */}

      {/* 스크랩은 마이페이지화면이 커뮤니티 레이아웃이라 매거진은 둘데가 없어 없애기로함 */}
      {/* <div className="l33">
        <a onClick={e => {
          e.preventDefault();
          e.stopPropagation();
          alert('todo_12: 스크랩!');
        }}>
          <img className="image" src="/assets/images/btn-favorite.svg" />
        </a>
      </div> */}

    </div>

    <div className="l2">
      {/* 패션 */}
      {props.data.category}
    </div>

    <div className="l3">
      {/* The Best Makeup Removers for Halloween and Beyond */}
      {props.me.title}
      {/* {props.data.title1} */}
    </div>

    <div className="l4">
      {/* 'CAME FROM THE BOTTOM' 나플라, 루피, 오왼 오바도즈, 그리고 김설희와 함께한 이야기,COMETRUE */}
      {props.me.subtitle}
      {/* {props.data.title2} */}
    </div>
    <div className="l5">
      <img className=" disposal" src="/assets/images/time.svg" /><span>{getNaturalTimeString(props.me.created_at)},</span>&nbsp;&nbsp;
      <img className=" disposal" src="/assets/images/view.svg" /><span>View {(props.me.view_count?props.me.view_count:0).toLocaleString()}</span>
    </div>

    <div className="dnom">&nbsp;</div>
    <div className="dnom">&nbsp;</div>
  </div>
</a>
  );
  return(jsx);
}